<template>
  <div>
    <unicom-barra-lateral-v3
      :largura="609"
      class="modificar-barra"
      v-model="barraLateral"
      :contemPaddingBody="false"
      :contemPaddingFooter="false"
      :alturaFooter="alturaFooterComputed"
    >
      <div slot="header">
        <div>
          <div
            class="titulo negrito cor-fonte fonte-primaria"
            v-if="quantidadeObservacoes <= 0"
          >
            Observações
          </div>
          <div
            class="titulo negrito cor-fonte fonte-primaria"
            v-else-if="pesquisandoObservacao"
          >
            Observações
            <span
              class="medio cor-principal"
              v-if="totalPesquisaObservacao > 0"
            >
              ({{ zeroEsquerda(totalPesquisaObservacao, 2) }})
            </span>
          </div>
          <div class="titulo negrito cor-fonte fonte-primaria" v-else>
            Observações
            <span class="medio cor-principal">
              ({{ zeroEsquerda(quantidadeObservacoes, 2) }})
            </span>
          </div>
        </div>
      </div>
      <ContainerObservacao
        ref="container-observacao"
        slot="body"
        v-if="quantidadeObservacoes > 0"
      />
      <ContainerObservacaoVazio
        slot="body"
        v-else
        @escrever-observacao="escreverObservacao"
      />
      <ContainerPesquisa
        @subir-scroll="
          $refs['container-observacao']
            ? $refs['container-observacao'].subirScroll()
            : ''
        "
        @altura-text-area="atualizarAlturaFooter"
        ref="container-pesquisa"
        slot="footer"
      />
    </unicom-barra-lateral-v3>
    <FiltroObservacoes
      ref="filtro"
      v-model="mostrarFiltroObservacoes"
      :listaAnalistas="listaAnalistas"
      @limpar-filtro="limparFiltro"
      @filtrar="filtrar"
    />
  </div>
</template>

<script>
import ContainerObservacao from "./ContainerObservacao";
import ContainerPesquisa from "./ContainerPesquisa";
import ContainerObservacaoVazio from "./ContainerObservacaoVazio";
import FiltroObservacoes from "./FiltroObservacoes";
import ObservacoesService from "./ObservacoesService";

export default {
  components: {
    ContainerObservacao,
    ContainerPesquisa,
    ContainerObservacaoVazio,
    FiltroObservacoes
  },
  mixins: [ObservacoesService],
  props: {
    value: {
      type: Boolean,
      required: true
    },
    observacoes: {
      type: Array,
      default: () => []
    },
    quantidadeObservacoes: {
      type: Number,
      default: 0
    },
    loadingContainer: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      barraLateral: this.value,
      alturaFooter: 88,
      alturaEspacamentosFooter: 80,
      listaAnalistas: []
    };
  },
  beforeMount() {
    this.recuperarAnalistas();
  },
  methods: {
    recuperarAnalistas() {
      this.getAnalistas().then(res => {
        this.listaAnalistas = res.data;
      });
    },
    escreverObservacao() {
      this.$refs["container-pesquisa"].focusInput();
    },
    subirHistorico() {
      this.$refs["body-historico"].scrollTo({ top: 0, behavior: "smooth" });
    },
    handlerSroll(evt) {
      const content = evt.target;

      if (content.scrollTop > 75) this.mostrarBotao = true;
      else this.mostrarBotao = false;
    },
    limparCampoPesquisa() {
      this.valorBarraPesquisa = "";
    },
    atualizarAlturaFooter(altura) {
      this.alturaFooter = altura;
    },
    filtrar(objetoFiltro) {
      this.$store.commit("setObjetoFiltroObservacoes", { ...objetoFiltro });
      this.$store.commit("setMostrarFiltroObservacoes", false);
      this.$store.dispatch("filtrarObservacoes", objetoFiltro);
    },
    limparFiltro() {
      this.$store.commit("setObjetoFiltroObservacoes", {});
      this.$store.commit("setMostrarFiltroObservacoes", false);
      this.$store.dispatch("inicializarObservacaoStore");
    }
  },
  computed: {
    mostrarFiltroObservacoes: {
      get() {
        return this.$store.getters.getMostrarFiltroObservacoes;
      },
      set(valor) {
        this.$store.commit("setMostrarFiltroObservacoes", valor);
      }
    },
    tituloComputed() {
      if (this.quantidadeObservacoes > 0) {
        return `Observações (${this.quantidadeObservacoes})`;
      }
      return "";
    },
    alturaFooterComputed() {
      return `${this.alturaFooter + this.alturaEspacamentosFooter}px`;
    },
    pesquisandoObservacao() {
      return this.$store.getters.getPesquisandoObersavacao;
    },
    totalPesquisaObservacao() {
      return this.$store.getters.getTotalPesquisaObservacao;
    }
    // mostrarFiltroObservacoes() {
    //   return true;
    // }
  },
  watch: {
    value() {
      this.$refs.filtro.limparCampos();
      if (this.value) {
        this.$store.commit("setLoadingModal", true);
        this.$store
          .dispatch("inicializarObservacaoStore")
          .then(() => {
            this.barraLateral = true;
          })
          .catch(() => {
            this.barraLateral = false;
          })
          .finally(() => {
            this.$store.commit("setLoadingModal", false);
          });
      } else {
        this.barraLateral = this.value;
      }
    },
    barraLateral() {
      if (!this.barraLateral && this.$store.getters.getIdEditando !== 0) {
        this.barraLateral = true;
        this.$store.dispatch("setMostrarModalConfirmarResumido", {
          mostrarModalConfirmar: true,
          callbackModalConfirmar: () => {
            this.$store.commit("setIdEditando", 0);
            this.$emit("input", false);
            this.$store.commit("setMostrarModalConfirmar", false);
          },
          tituloModalConfirmar: "Deseja sair da edição?",
          mensagemModalConfirmar:
            "Existe uma edição em andamento. Ao sair, as alterações realizadas serão perdidas.",
          textoBotaoModalConfirmar: "CONFIRMAR",
          tipoBotaoModalConfirmar: "importante"
        });
      } else {
        this.$emit("input", this.barraLateral);
      }
    }
  }
};
</script>
